import MessageModal from "../components/modals/MessageModal";
import EmailInput from "../pages/EmailInput";
import Prijava from "../pages/Prijava";
import Registracija from "../pages/Registracija";

export const ModalRegistry = {
    prijava: Prijava,
    registracija: Registracija,
    messageModal: MessageModal,
    emailInput: EmailInput
}